import React from "react";
import { Modal } from "antd";
import Button from "./button";

const CustomOkButton = ({ onClick }) => (
  <Button title="Done" type={"primary"} onClick={onClick} />
);

const MemberModal = ({ onCancel, onOk, text, title, image }) => {
  return (
    <div>
      <Modal
        open={true}
        footer={null}
        maskClosable={true}
        closeIcon={null}
        className="space-y-20 "
        onCancel={onCancel}
        width="422px"
      >
        <div className="flex justify-center rounded-xl">
          <img src={image} alt="no-img" />
        </div>
        <div className="flex justify-center py-2 text-center">
          <h2 className="text-black text-center font-Almarai font-bold text-2xl">
            {title}
          </h2>
        </div>
        <div className="flex justify-center py-2 px-12">
          <p className="font-medium text-sm text-center">{text}</p>
        </div>

        <div className="flex space-x-2 sm:space-x-0 flex-row justify-between mt-2">
          <CustomOkButton onClick={onOk} />
        </div>
      </Modal>
    </div>
  );
};
export default MemberModal;
